import { PageType } from './constants';

export type UserJourney = 'welcome' | 'product' | 'admin' | 'enrich';

interface RouteMapping {
  page: PageType | null;
  journey: UserJourney;
  product?: 'AIS' | 'PIS';
}

const ROUTE_MAP: Record<string, RouteMapping> = {
  '/payment/launch': { page: 'pisV2', journey: 'product', product: 'PIS' },
  '/account/launch': { page: 'aisV2', journey: 'product', product: 'AIS' },
  '/payment': { page: null, journey: 'product', product: 'PIS' },
  '/account': { page: null, journey: 'product', product: 'AIS' },
  '/enrich': { page: null, journey: 'enrich' },
  '/admin': { page: null, journey: 'admin' },
};

const DEFAULT_MAPPING: RouteMapping = {
  page: null,
  journey: 'welcome',
};

export function getRouteMapping(pathname: string): RouteMapping {
  return ROUTE_MAP[pathname] ?? DEFAULT_MAPPING;
}

export function getPageFromPath(pathname: string): PageType | null {
  return getRouteMapping(pathname).page;
}
